export enum SelectFilterOperationType {
  Is = 'Is',
  IsNot = 'IsNot',
  IsOneOf = 'IsOneOf',
  IsNoneOf = 'IsNoneOf',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  IsAtLeast = 'IsAtLeast',
  IsAtMost = 'IsAtMost',
}
